import * as types from "./types";

export const set_persist = (payload) => ({
  type: types.SET_PERSIST_REDUCER,
  payload,
});
